export default __webpack_public_path__ + "static/media/measure.aed62990.png";